import { render } from "./Register.vue?vue&type=template&id=1b39e732"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\grntm\\OneDrive\\Study\\Vue Mastery\\real-world-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__